import { Status } from "./Status";


export class ReturnsStatusSmartEnum {
    static Draft = new Status("Draft", 1, "pill--yellow");
    static Submitted = new Status("Submitted", 2, "pill--blue");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "ReturnsStatusSmartEnum";
    }
}


